module.exports = __webpack_public_path__ + "media/images/icons/icon_calendar_grey-e41ec9b09f73a65e4ef7cf22e0534450.svg";